import { blockAdapterBase } from 'volto-ministerio-publico-federal/helpers/BlockAdapter/BlockAdapter';
import type { DestaqueCarrosselItem } from 'volto-ministerio-publico-federal/components/View/CapaView/helpers';

interface PageBrain {
  Title?: string;
  Description?: string;
  [key: string]: unknown;
}

/**
 * Ao escolher o conteúdo no campo Conteúdo, herda título e descrição.
 *
 * Só preenche campo vazio — mesma política de `Destaques/adapter.ts`. A imagem
 * não entra: no slide ela é fundo de um véu colorido, sempre arte dedicada.
 */
export const buildDestaqueCarrosselFields = (
  page: PageBrain,
  item: DestaqueCarrosselItem = {},
): Partial<DestaqueCarrosselItem> => {
  const patch: Partial<DestaqueCarrosselItem> = {};
  if (!item.title && page.Title) patch.title = page.Title;
  if (!item.description && page.Description)
    patch.description = page.Description;
  return patch;
};

export const DestaquesCarrosselBlockDataAdapter = ({
  block,
  data,
  id,
  onChangeBlock,
  value,
}: {
  block: string;
  data: Record<string, unknown>;
  id: string;
  onChangeBlock: (block: string, data: unknown) => void;
  value: unknown;
}) => {
  blockAdapterBase(
    block,
    data,
    id,
    onChangeBlock,
    value,
    'items',
    buildDestaqueCarrosselFields,
  );
};

export default DestaquesCarrosselBlockDataAdapter;
